import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { Tag } from 'sonata-react-components';

import { formatFlightDate } from './flightSettings.helpers';

import type { Moment } from 'moment-timezone';

type Props = {
  /** Every flight date set (date-only UTC). */
  dates: Moment[];
  flightsCount: number;
};

/** Title + "N flights" / "Time window" tags + description (Figma 8734:934). */
export function FlightSettingsHeader({ dates, flightsCount }: Props) {
  const { formatMessage } = useIntl();

  return (
    <header className="flightSettings__header">
      <div className="flightSettings__headerRow">
        <h4 className="flightSettings__headerTitle">
          {formatMessage({ defaultMessage: 'Flight Settings', id: 'spc.flightSettings.title' })}
        </h4>
        <Tag id="flightSettings-flightsCount" status="information">
          {formatMessage(
            {
              defaultMessage: '{count, plural, one {# flight} other {# flights}}',
              id: 'spc.flightSettings.tag.flights'
            },
            { count: flightsCount }
          )}
        </Tag>
        {dates.length > 0 && (
          <Tag id="flightSettings-timeWindow" status="information">
            {formatMessage(
              { defaultMessage: 'Time window: {start}-{end}', id: 'spc.flightSettings.tag.timeWindow' },
              {
                end: formatFlightDate(moment.max(dates)),
                start: formatFlightDate(moment.min(dates))
              }
            )}
          </Tag>
        )}
      </div>
      <p className="flightSettings__headerDescription">
        {formatMessage({
          defaultMessage: 'Optimize budget distribution with scheduled ad flights',
          id: 'spc.flightSettings.description'
        })}
      </p>
    </header>
  );
}
